import React from 'react';
import Testimonials from '../../Testimonials';

interface Props {
  testimonialCategory: any; // Union type from GraphQL
}

const RetirementVillageTestimonials = ({ testimonialCategory }: Props) => {
  // Create a fragment that matches what Testimonials expects
  const fragment = {
    __typename: 'pageContent_testimonialsBlock_BlockType' as const,
    uid: 'retirement-village-testimonials',
    testimonialCategory: testimonialCategory,
    headingTextPrimary: 'What do our residents say?',
    imageLayout: true, // Use the new image layout
  };

  return <Testimonials fragment={fragment as any} />;
};

export default RetirementVillageTestimonials;

